import React from 'react';

interface DillFieldProps {
  label: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const DillField = ({ label, error, required, children, className }: DillFieldProps) => (
  <div className={`flex flex-col gap-1${className ? ` ${className}` : ''}`}>
    {label && (
      <label className="text-[11px] font-medium text-gray-400 uppercase tracking-wide">
        {label}
        {required && <span className="text-red-400 ml-0.5">*</span>}
      </label>
    )}
    {children}
    {error && <span className="text-[11px] text-red-500">{error}</span>}
  </div>
);
